import { makeV2APIURL } from '^/store/duck/API';
import { belongsToPlan } from '^/utilities/plans';

export enum AUTH_KEYS {
  GetAuthedUser = 'GetAuthedUser',
  GetLanguage = 'GetLanguage',
  CheckEmail = 'Email',
}

export const AuthKeys = {
  getAuthedUserKey: [AUTH_KEYS.GetAuthedUser],
  getLanguageKey: [AUTH_KEYS.GetLanguage],
  checkEmailKey: (email?: string) => [AUTH_KEYS.CheckEmail, email],
};

export const getPlanURL = (slug?: string) =>
  belongsToPlan(slug)
    ? makeV2APIURL('plans', slug ?? '', 'signin')
    : makeV2APIURL('auth', 'signin');
